'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconComment, iconCommentTag } from '@ni/nimble-components/dist/esm/icons/comment';
import { wrap } from '../../utilities/react-wrapper';

export type { IconComment };
export { iconCommentTag };
export const NimbleIconComment = wrap(IconComment);